const state = {
  isFilterApplied: false,
  brands: null,
  otherInterests: [],
  Interests: [],
  insurance: { health: null,
    tractor: null,
    others: null,
    crops: null,},
  engagement: null,
  selectedDistrict: [],
  formattedCropsData: null,
  CropsIdData: [],
  selectedCrops: [],
  isAllSelectedCrops: [],
  statesId: [],
  page: 1,
  isCropTypeSelected: [],
  filterPayload: {
    location: {
      state_id: [],
      district_id: [],
    },
    interest: {
      other_interest: [],
      business_interest: [],
    },
    crops: {
      crop_type_id: [],
      crop_id: [],
    },

    insurance: {
      crop_insurance: null,
      tractor_insurance: null,
      health_insurance: null,
      other_insurance: null,
    },
    engagement: {
      life_time_value: {
        min_value: null,
        max_value: null,
      },
      profile_completion: {
        min_value: null,
        max_value: null,
      },
      risk_level: [],
    },
    ownership: {
      land: {
        land_ownership: null,
        land_holding_size: [],
      },
      tractor: {
        tractor_ownership: null,
        tractor_brand: [],
      },
      cattle: {
        animal_ownership: null,
        animal_own_count: [],
        animal_interest: [],
      },
    },
    brands:[]
  },
};

const mutations = {
  SET_PAGE: (state, value) => {
    console.log("page", state, value);
    state.page = value;
  },
  SET_BRANDS_DATA: (state, value) => {
    console.log("SET_BRANDS_DATA", state, value);
    state.brands = value;
  },

  SET_INTERESTS_DATA: (state, value) => {
    console.log("state", state, value);
    state.Interests = value;
  },
  SET_OTHER_INTERESTS_DATA: (state, value) => {
    console.log("state", state, value);
    state.otherInterests = value;
  },
  SET_INSURANCE_DATA: (state, value) => {
    console.log("SET_INSURANCE_DATA", state, value);
    state.insurance = value;
  },
  SET_ENGAGEMENT_DATA: (state, value) => {
    console.log("SET_ENGAGEMENT_DATA", state, value);
    state.engagement = value;
  },
  SET_SELECTED_DISTRDICT_DATA: (state, value) => {
    console.log("SET_SELECTED_DISTRDICT_DATA", state, value);
    state.selectedDistrict = value;
  },
  SET_CROPS_FORMATTED_DATA: (state, value) => {
    console.log("SET_CROPS_FORMATTED_DATA", state, value);
    state.formattedCropsData = value;
  },
  SET_CROPS_ID: (state, value) => {
    console.log("SET_CROPS_ID", state, value);
    state.CropsIdData = value;
  },
  SET_ALL_SELECTED_CROPS_TYPE_ID: (state, value) => {
    console.log("SET_CROPS_ID", state, value);
    state.isAllSelectedCrops = value;
  },
  SET_SELECTED_CROPS_TYPE_ID: (state, value) => {
    console.log("SET_CROPS_ID", state, value);
    state.selectedCrops = value;
  },
  SET_STATES_ID: (state, value) => {
    console.log("SET_STATES_ID", state, value);
    state.statesId = value;
  },
  SET_IS_ALL_CROP_TYPE_SELECTED: (state, value) => {
    console.log("SET_IS_ALL_CROP_TYPE_SELECTED", state, value);
    state.isCropTypeSelected = value;
  },
  SET_FILTER_PAYLOAD: (state, value) => {
    console.log("SET_FILTER_PAYLOAD", state, value);
    state.filterPayload = value;
  },
  SET_IS_FILTER_APPLIED: (state, value) => {
    console.log("SET_IS_FILTER_APPLIED", state, value);
    state.isFilterApplied = value;
  },
  SET_OWNERSHIP_DATA: (state, value) => {
    console.log("SET_OWNERSHIP_DATA", state, value);
    state.ownership = value;
  },
};

const actions = {
  setPage({ commit }, data) {
    commit("SET_PAGE", data);
  },
  setStatesData({ commit }, data) {
    commit("SET_STATES_ID", data);
  },
  setBrandsData({ commit }, data) {
    commit("SET_BRANDS_DATA", data);
  },
  setInterests({ commit }, data) {
    commit("SET_INTERESTS_DATA", data);
  },
  setOtherInterests({ commit }, data) {
    commit("SET_OTHER_INTERESTS_DATA", data);
  },
  setInsurance({ commit }, data) {
    commit("SET_INSURANCE_DATA", data);
  },
  setEngagement({ commit }, data) {
    commit("SET_ENGAGEMENT_DATA", data);
  },
  setSlecetdDistrits({ commit }, data) {
    commit("SET_SELECTED_DISTRDICT_DATA", data);
  },
  setCropsFormatted({ commit }, data) {
    commit("SET_CROPS_FORMATTED_DATA", data);
  },
  setCropsId({ commit }, data) {
    commit("SET_CROPS_ID", data);
  },
  setCropsTyepId({ commit }, data) {
    commit("CROPS_TYPE_ID", data);
  },
  setAllCropsTypeId({ commit }, data) {
    commit("SET_ALL_SELECTED_CROPS_TYPE_ID", data);
  },
  setIsAllCropsTypeIdSelected({ commit }, data) {
    commit("SET_IS_ALL_CROP_TYPE_SELECTED", data);
  },
  setFilterPayload({ commit }, data) {
    commit("SET_FILTER_PAYLOAD", data);
  },
  setFilterApplied({ commit }, data) {
    commit("SET_IS_FILTER_APPLIED", data);
  },
  setOwnership({ commit }, data) {
    commit("SET_OWNERSHIP_DATA", data);
  },
  //SET_IS_FILTER_APPLIED
};

const getters = {
  GET_PAGE: (state) => state.page,
  GET_STATES_DATA: (state) => state.statesId,
  GET_BRANDS_DATA: (state) => state.brands,
  GET_OTHER_INTERESTS_DATA: (state) => state.otherInterests,
  GET_INTERESTS_DATA: (state) => state.Interests,
  GET_INSURANCE_DATA: (state) => state.insurance,
  GET_ENGAGEMENT_DATA: (state) => state.engagement,
  GET_SELECTED_DISTRDICT_DATA: (state) => state.selectedDistrict,
  GET_CROPS_FORMATTED_DATA: (state) => state.formattedCropsData,
  GET_IS_ALL_CROP_TYPE_SELECTED: (state) => state.isCropTypeSelected,
  GET_CROPS_ID_DATA: (state) => state.CropsIdData,
  GET_SELECTED_CROPS_TYPE_ID: (state) => state.selectedCrops,
  GET_ALL_SELECTED_CROPS_TYPE_ID: (state) => state.isAllSelectedCrops,
  GET_FILTER_PAYLOAD: (state) => state.filterPayload,
  GET_IS_FILTER_APPLIED: (state) => state.isFilterApplied,
  GET_OWNERSHIP_DATA: (state) => state.ownership,
};//SET_OWNERSHIP_DATA

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};


